<div class="ds-modal ds-modal--auto sede">
    <div class="ds-accent"></div>

    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">home_work</span>
        <div>
            <h2>Información de usuario</h2>
            <p>Sede asignada y reasignación</p>
        </div>
        <span class="ds-modal__spacer"></span>
        <button type="button" class="ds-icon-btn" (click)="dialogRef.close()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <div class="ds-modal__body">
        <app-spinner
            [show]="!sede && !flag"
            [text]="'Cargando sede...'"
            [type]="'absolute'"
            [color]="'#B1476A'"
            [trackColor]="'#4CA7C8'"
            [blurBackground]="true"
        ></app-spinner>

        <div class="ds-alert ds-alert--danger" *ngIf="!sede && flag">
            <span class="material-icons">warning</span>
            <div>Sin sede asignada.</div>
        </div>

        <div class="ds-card" *ngIf="sede">
            <div class="ds-section__head">
                <span class="material-icons">place</span>
                Sede asignada
            </div>
            <div class="ds-section__body">
                <p class="sede__actual">{{ sede.nombre }}</p>
            </div>
        </div>

        <div class="ds-card">
            <div class="ds-section__head">
                <span class="material-icons">swap_horiz</span>
                Reasignar sede
            </div>
            <div class="ds-section__body">
                <form [formGroup]="form" (ngSubmit)="guardarSede()">
                    <div class="ds-field">
                        <label class="ds-field__label" for="sede-select">Seleccionar sede</label>
                        <div class="ds-field__control">
                            <select id="sede-select" class="ds-field__select"
                                formControlName="signoSedes" (change)="onSedeChange($event)">
                                <option value="" disabled>Seleccione una sede</option>
                                <option *ngFor="let s of sedes" [value]="s._id">{{ s.nombre }}</option>
                            </select>
                            <span class="ds-field__caret material-icons">expand_more</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="ds-modal__actions">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="dialogRef.close()">Cerrar</button>
        <button type="button" class="ds-pill ds-pill--primary"
            [disabled]="!form || form.invalid || btnActualizar" (click)="guardarSede()">
            <span class="material-icons">save</span>
            Actualizar
        </button>
    </div>
</div>
